export class ScrollHandler {
  constructor(options = {}) {
    this.lastScrollTop = 0;
    this.ticking = false;
    this.headerElement = document.querySelector('header');
    this.footerElement = document.querySelector('footer');
    this.footerTopOffset = 0;
    this.footerHeight = 0;
    this.contextualNavElement = document.querySelector('.navigation--contextual');
    this.contextualNavOffset = 0;
    this.threshold = options.threshold || 50; // scroll threshold before toggling visibility
    this.hiddenClass = options.hiddenClass || 'header--hidden';
    this.fixedClass = options.fixedClass || 'header--fixed';
    this.absoluteClass = options.absoluteClass || 'header--absolute';
    this.transitionAllowedClass = options.transitionAllowedClass || 'header--can-transition';
    this.isScrolling = false;
    this.allowTransition = false;
    this.onScroll = this.onScroll.bind(this);
  }

  init() {
    if (this.headerElement) {
      this.headerElement.classList.add(this.absoluteClass);
      this.headerElement.classList.remove(this.fixedClass);
    }
    window.addEventListener('scroll', this.onScroll);
    this.updateFooterOffset();
    this.updateContextualNavOffset();
    window.addEventListener('resize', () => this.updateFooterOffset());
    window.addEventListener('resize', () => this.updateContextualNavOffset());

    this.scrollToActiveButton();
  }

  onScroll() {
    this.isScrolling = true;
    clearTimeout(this.scrollTimeout);

    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.handleScroll();
        this.ticking = false;
      });
      this.ticking = true;
    }

    this.scrollTimeout = setTimeout(() => {
      this.isScrolling = false;
    }, 150);
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Switch to fixed if scrolled more than 130px
    if (scrollTop > 130) {
      if (this.headerElement && !this.headerElement.classList.contains(this.fixedClass)) {
        this.headerElement.classList.add(this.fixedClass);
        this.headerElement.classList.remove(this.absoluteClass);
        setTimeout(() => {
          this.allowTransition = true;
          if (this.headerElement) {
            this.headerElement.classList.add(this.transitionAllowedClass);
          }
        }, 100);
      }
    } else {
      // If we're at the very top and not actively scrolling, switch back to absolute
      if (scrollTop <= 0) {
        this.headerElement.classList.remove(this.fixedClass);
        this.headerElement.classList.add(this.absoluteClass);
        this.allowTransition = false;
        if (this.headerElement) {
          this.headerElement.classList.remove(this.transitionAllowedClass);
        }
      }
    }

    // Detect scroll direction
    if (scrollTop > this.lastScrollTop && scrollTop > this.threshold) {
      // scrolling down
      if (this.headerElement && !this.headerElement.classList.contains(this.hiddenClass)) {
        this.headerElement.classList.add(this.hiddenClass);
      }
    } else {
      // scrolling up
      if (this.headerElement && this.headerElement.classList.contains(this.hiddenClass)) {
        this.headerElement.classList.remove(this.hiddenClass);
      }
    }

    if (this.contextualNavElement) {
      if (scrollTop > this.contextualNavOffset) {
        this.contextualNavElement.classList.add('has-shadow');
      } else {
        this.contextualNavElement.classList.remove('has-shadow');
      }
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

    const formWrap = document.querySelector('.form__wrap--buy-button');
    if (formWrap && this.footerElement) {
      const scrollBottom = window.pageYOffset + window.innerHeight;
      const footerVisible =
        scrollBottom >= this.footerTopOffset && window.pageYOffset <= this.footerTopOffset + this.footerHeight;
      formWrap.classList.toggle('passive', footerVisible);
    }
  }

  updateFooterOffset() {
    if (this.footerElement) {
      const rect = this.footerElement.getBoundingClientRect();
      this.footerTopOffset = rect.top + window.pageYOffset;
      this.footerHeight = rect.height;
    }
  }

  updateContextualNavOffset() {
    if (this.contextualNavElement) {
      const rect = this.contextualNavElement.getBoundingClientRect();
      this.contextualNavOffset = rect.top + window.pageYOffset - 106;
    }
  }

  scrollToActiveButton() {
    if (window.innerWidth >= 768) return; // only run on small screens

    const buttonLists = document.querySelectorAll('.button__list');

    if (!buttonLists || buttonLists.length === 0) return;
    buttonLists.forEach((buttonList) => {
      const activeButton = buttonList.querySelector('.active');

      if (activeButton) {
        const buttonListRect = buttonList.getBoundingClientRect();
        const activeButtonRect = activeButton.getBoundingClientRect();

        // Check if active button is outside the visible area
        if (activeButtonRect.left < buttonListRect.left || activeButtonRect.right > buttonListRect.right) {
          const offset = activeButton.offsetLeft - buttonList.clientWidth / 2 + activeButton.clientWidth / 2;

          buttonList.scrollTo({
            left: offset,
          });
        }
      }
    });
  }
}